<h1 mat-dialog-title>
  <ng-container *ngIf="!exemptEnrol && !freeEnrol"
                i18n="Contest Payment Modal|Contest Payment modal title@@contest-payment-modal-title">
    Pay for Enrollment
  </ng-container>
  <ng-container *ngIf="exemptEnrol"
                i18n="Contest Exempt Payment Modal|Contest Exempt Payment modal title@@contest-exempt-payment-modal-title">
    Exempt Enrollment
  </ng-container>
  <ng-container *ngIf="freeEnrol"
                i18n="Contest Exempt Payment Modal|Contest No Payment modal title@@contest-no-payment-modal-title">
    Free Enrollment
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content no-focus">
  <div *ngIf="!exemptEnrol && !freeEnrol" class="payment-details">
    <iframe *ngIf="paymentPageUrl"
            width="100%"
            height="100%"
            class="iframe-content"
            [class.x-small-iframe-content]="xSmallScreenView"
            [src]="paymentPageUrl"></iframe>
  </div>
  <div *ngIf="exemptEnrol" class="full-width content-container">
    <span class="exempt-enrol-message"
          i18n="Contest Payment Modal|Contest Exempt Payment contact host message@@contest-exempt-payment-contact-host-message">
      To use the exempt enrollment, contact a organizer of the competition:
    </span>
    <ul *ngIf="hosts">
      <li *ngFor="let host of hosts">
        <span class="mat-body-strong">{{host.firstName || ''}} {{host.lastName || ''}} &nbsp;</span>
        <span>(&nbsp;<app-link [href]="'mailto:' + host.email"
                               class="link"
                               [label]="host.email"
                               [external]="true"></app-link>)</span>
      </li>
    </ul>
  </div>

  <div *ngIf="freeEnrol && (!group || !group.length)" class="full-width center-align content-container"
       i18n="Contest Payment Modal|Contest free enrol confirmation@@contest-free-enrol-confirmation">
    Do you wish to continue with free user enrollment?
  </div>
  <div *ngIf="freeEnrol && group && group.length > 0" class="full-width center-align content-container"
       i18n="Contest Payment Modal|Contest group free enrol confirmation@@contest-group-free-enrol-confirmation">
    By continuing you will enrol this group for free. Do you wish to continue?
  </div>
</div>
<div mat-dialog-actions>
  <app-button *ngIf="exemptEnrol"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>

  <app-button *ngIf="freeEnrol"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>

  <span *ngIf="freeEnrol" class="btn-spacer"></span>

  <app-button *ngIf="freeEnrol"
              label="Free Enrol"
              i18n-label="General|Free Enrol action label@@general-free-enrol-action-label"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"></app-button>
</div>
